<template>
    <div>
        <div class="sidebar-list">
            <ul class="menu">
                <li @click="OpenModel('toggle-patient-record-modal')">
                    <common-icon name="record" size="large"></common-icon>
                    <p class="patient-profile-sidebar">{{ $t('modals.sidebarList.content.record') }}</p>
                </li>
                <li @click="OpenModel('toggle-check-password-modal')">
                    <common-icon name="edit" size="large"></common-icon>
                    <p class="patient-profile-sidebar">{{ $t('modals.sidebarList.content.information') }}</p>
                </li>
                <li @click="OpenModel('toggle-patient-message-modal')">
                    <common-icon name="message" size="large"></common-icon>
                    <p class="patient-profile-sidebar">{{ $t('modals.sidebarList.content.message') }}</p>
                </li>
                <li
                    :class="{ 'patient-sidebar-item--active': isAccidentIntakeActive }"
                    @click="OpenModel('toggle-accident-intake')"
                >
                    <common-icon name="file" size="large"></common-icon>
                    <p class="patient-profile-sidebar">{{ $t('modals.sidebarList.content.accident_intake') }}</p>
                </li>
                <li class="delet-data" @click="OpenModel('toggle-delete-patient-modal')">
                    <common-icon name="trash-bin" size="large"></common-icon>
                    <p class="patient-profile-sidebars">{{ $t('modals.sidebarList.content.remove') }}</p>
                </li>
            </ul>

            <div v-if="physician.mcard && physician.mcard.primaryCareProvider" class="physician">
                <h4>{{ $t('modals.sidebarList.physician.title') }}</h4>
                <div class="doctor-info">
                    <div class="doctor-avatar">
                        {{ physician?.mcard?.primaryCareProvider?.firstName.charAt(0)
                        }}{{ physician?.mcard?.primaryCareProvider?.lastName.charAt(0) }}
                    </div>
                    <div class="doctor-layout">
                        <p class="doctor-name">
                            {{ $t('modals.sidebarList.physician.dr') }} {{ physician?.mcard?.primaryCareProvider?.firstName }}
                            {{ physician?.mcard?.primaryCareProvider?.lastName }}
                        </p>
                        <p class="text-muted">{{ physician?.mcard?.primaryCareProvider?.email }}</p>
                        <p class="text-mute">
                            <common-icon name="phone" size="large"></common-icon>
                            {{ physician?.mcard?.primaryCareProvider?.phone }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PhysicianMixin from 'mixins/PhysicianMixin'
    export default {
        mixins: [PhysicianMixin],
        props: {
            physician: { type: Object, required: true },
            isAccidentIntakeActive: { type: Boolean, default: false },
        },
        methods: {
            OpenModel(modalName) {
                if (modalName === 'toggle-patient-record-modal') {
                    this.$router.push({ name: 'patients.all-details.patients', params: { id: this.$route.params.id } })
                }
                this.$emit('toggle', modalName)
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/components/patients/_patient';

    .patient-sidebar-item--active {
        .patient-profile-sidebar {
            color: #1447e6;
            font-weight: 600;
        }
    }
</style>
